<template>
  <router-view></router-view>
</template>

<script>
import '@progress/kendo-ui'
import '@progress/kendo-theme-default/dist/all.css'

export default {
  name: 'app',
  beforeCreate () {
    window.kendo.cultures['id-ID'] = {
      name: 'id-ID',
      numberFormat: {
        pattern: ['-n'],
        decimals: 1,
        ',': '.',
        '.': ',',
        groupSize: [3],
        percent: {
          pattern: ['-n%', 'n%'],
          decimals: 2,
          ',': ',',
          '.': '.',
          groupSize: [3],
          symbol: '%'
        },
        currency: {
          name: 'Indonesian Rupiah',
          abbr: 'IDR',
          pattern: ['$ -n', '$ n'],
          decimals: 0,
          ',': ',',
          '.': '.',
          groupSize: [3],
          symbol: 'Rp'
        }
      },
      calendars: {
        standard: {
          days: {
            names: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            namesAbbr: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            namesShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
          },
          months: {
            names: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            namesAbbr: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
          },
          AM: ['AM'],
          PM: ['PM'],
          patterns: {
            d: 'dd-MM-yyyy',
            D: 'd MMMM yyyy г.',
            F: 'd MMMM yyyy г. H:mm:ss',
            g: 'dd-MM-yyyy H:mm',
            G: 'dd-MM-yyyy H:mm:ss',
            m: 'd MMM',
            M: 'd MMMM',
            s: 'yyyy-MM-ddTHH:mm:ss',
            t: 'H:mm',
            T: 'H:mm:ss',
            u: 'yyyy-MM-dd HH:mm:ssZ',
            y: 'MMMM yyyy',
            Y: 'MMMM yyyy'
          },
          '/': '.',
          ':': ':',
          firstDay: 0
        }
      }
    }
    window.kendo.culture('id-ID')
  }
}
</script>
<style lang="scss">
  // Import Main styles for this application
  @import "./scss/style";

  #app, .k-widget {
    font-size: 13px !important;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue